"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCodecError = void 0;
/**
 * Checks the error message to see if it is an io-ts codec error
 * @param err - The error obj
 * @returns whether it is a io-ts codec error
 */
function isCodecError(err) {
    return err.message.startsWith('Failed to decode codec');
}
exports.isCodecError = isCodecError;
//# sourceMappingURL=isCodecError.js.map